

























import { Component, Prop, Vue } from 'vue-property-decorator';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';

@Component({
  components: {
    PrimaryButton,
  },
})
export default class EditConfirmation extends Vue {
  @Prop({ default: false }) readonly loading: boolean = false;

  public onCancel() {
    this.$emit('cancel');
  }

  public onSave() {
    this.$emit('save');
  }
}
